import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Bar = styled.nav`
  position: sticky;
  top: 0;
  inset-inline: 0;
  z-index: 100;
  backdrop-filter: blur(12px) saturate(140%);
  background: ${({theme})=>theme.colors.surfaceAlpha};
  padding: ${({theme})=>theme.space.md} ${({theme})=>theme.space.lg};
  border-bottom: 1px solid ${({theme})=>theme.colors.border};
  box-shadow: ${({theme})=>theme.shadows.sm};
  transition: background var(--motion-normal), box-shadow var(--motion-normal);
`;

const Container = styled.div`
  max-width: 70rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Brand = styled(Link)`
  font-family: ${({theme})=>theme.fonts.heading};
  font-size: 1.25rem;
  font-weight: 700;
  color: ${({theme})=>theme.colors.primary};
  letter-spacing: -0.02em;
  transition: color var(--motion-fast), transform var(--motion-fast);

  &:hover {
    color: ${({theme})=>theme.colors.primaryDark};
    transform: translateY(-2px);
  }
`;

const Button = styled(Link)`
  background: linear-gradient(45deg, #e63946 0%, #e63946dd 100%);
  color: white;
  padding: 7px 32px;
  border-radius: 50px;
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 2px solid transparent;

  
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(230, 57, 70, 0.2);
    background: linear-gradient(45deg, #e63946dd 0%, #e63946 100%);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 14px 28px;
  }
  @media (max-width: 480px) {
    font-size: 0.9rem;
    padding: 12px 24px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-top: 30px;
  
  @media (max-width: 480px) {
    gap: 12px;
  }
`;

export default function NavBar() {
  return (
    <Bar>
      <Container>
        <Brand to="/">MyPunch Blog</Brand>
        <Button to="https://punchia.online">
          Ir a pagina MyPunch
        </Button>
      </Container>
    </Bar>
  );
}
